<template>
  <div id="app">
    <page>
      <!-- Hero -->

      <section-hero></section-hero>

      <!-- Content -->

      <section-content>
        <container>
          <section-title>Lorem Ipsum Dolor Sit Amet</section-title>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod <rad-link>tempor incididunt</rad-link> ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <flex>
            <flex-item>
              <article-link
                href="jordanranson.com"
                title="Lorem Ipsum Dolor Sit Amet"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </article-link>
            </flex-item>
            <flex-item>
              <article-link
                href="jordanranson.com"
                title="Lorem Ipsum Dolor Sit Amet"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </article-link>
            </flex-item>
          </flex>
          <flex>
            <flex-item>
              <article-link
                href="jordanranson.com"
                title="Lorem Ipsum Dolor Sit Amet"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </article-link>
            </flex-item>
            <flex-item>
              <article-link
                href="jordanranson.com"
                title="Lorem Ipsum Dolor Sit Amet"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </article-link>
            </flex-item>
          </flex>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <glossary-table title="Glossary">
            <glossary-row
              item="foo"
              type="string"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </glossary-row>
            <glossary-row
              item="bar"
              type="optional string"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </glossary-row>
            <glossary-row
              item="baz"
              type="function"
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </glossary-row>
          </glossary-table>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <code-example title="JavaScript">
            <code-snippet>
{
  "x": 0,
  "y": 0,
  "items": [],
  "width": 300,
  "height": 300,
  "margin": 10,
  "anchors": "left top",
  "direction": "row"
}
            </code-snippet>
            <code-demo>
              Lorem ipsum dolor sit amet.
            </code-demo>
          </code-example>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        </container>
      </section-content>

      <!-- Footer -->

      <section-footer></section-footer>
    </page>
  </div>
</template>

<script>
import bombAssComponents from '@/bomb-ass-project-template.js'

export default {
  name: 'App',

  components: {
    ...bombAssComponents
  }
}
</script>

<style lang="sass">
@import '@/styles/styles.sass'
@import url('https://fonts.googleapis.com/css?family=Karla')
@import url('https://fonts.googleapis.com/css?family=Inconsolata')

html,
body
  font-family: 'Karla', sans-serif

pre,
code
  font-family: 'Inconsolata', monospace
</style>
